

import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";
import { DateLocaleService } from "../../services/date-locale-service";

export class BillingConfigController {
    static $inject = ["$scope", "$window", "$location", "$filter", "$q", "adminConfigService", "notifyService", "dateLocaleService"];
    contactName: Models.IDivSetting[];
    emailAddress: Models.IDivSetting[];
    billingAddress: Models.IDivSetting[];

    suiteNumber: Models.IDivSetting[];
    city: Models.IDivSetting[];
    state: Models.IDivSetting[];

    country: Models.IDivSetting[];

    editContactName: Models.IDivSetting;
    editEmailAddress: Models.IDivSetting;
    editBillingAddress: Models.IDivSetting;

    editSuiteNumber: Models.IDivSetting;
    editCity: Models.IDivSetting;
    editState: Models.IDivSetting;

    editCountry: Models.IDivSetting;
    divLicenseAmt: Models.IDivSetting[];
    billingID: Models.IDivSetting[];
    billingMethod: Models.IDivSetting[];
    editBillingID: Models.IDivSetting;
    editBillingMethod: Models.IDivSetting;
    createModal: boolean;
    emailValid: boolean;
    constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $location: ng.ILocationService, private $filter: ng.IFilterService,
        private $q: ng.IQService, private adminConfigService: AdminConfigService, private notifyService: NotifyService,
        private dateLocaleService: DateLocaleService) {

        this.createModal = false;

        this.contactName = [];
        this.emailAddress = [];
        this.billingAddress = [];

        this.suiteNumber = [];
        this.city = [];
        this.state = [];

        this.divLicenseAmt = [];
        this.country = [];
        this.billingID = [];
        this.billingMethod = [];

        this.emailValid = true

        var emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

    }

    Init() {
        var promise1 = this.adminConfigService.getDivSettingList()
            .then((result) => {
                this.contactName = result.filter(s => s.key == "billContactName");
                this.emailAddress = result.filter(s => s.key == "billEmailAddress");
                this.billingAddress = result.filter(s => s.key == "billBillingAddress");
                this.suiteNumber = result.filter(s => s.key == "billSuiteNumber");
                this.city = result.filter(s => s.key == "billCity");
                this.state = result.filter(s => s.key == "billState");
                this.country = result.filter(s => s.key == "billCountry");
                this.billingMethod = result.filter(s => s.key == "billMethod");
                this.divLicenseAmt = result.filter(s => s.key == "licenseAllocation");
                this.billingID = result.filter(s => s.key == "divBillID");
            });

        this.$q.all([promise1])
            .then(() => {
            });
    }
    Edit() {
        this.createModal = true;

        this.editContactName = this.contactName[0];
        this.editEmailAddress = this.emailAddress[0];
        this.editBillingAddress = this.billingAddress[0];

        this.editSuiteNumber = this.suiteNumber[0];
        this.editCity = this.city[0];
        this.editState = this.state[0];
        this.editCountry = this.country[0];
        this.editBillingMethod = this.billingMethod[0];

    };

    Save() {
        try {
            this.notifyService.startProgress();
            if (_.isEmpty(this.billingID) || this.billingID == undefined) {
                this.adminConfigService.createBillID()
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin Name Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            if (_.isEmpty(this.contactName) && this.editContactName !== undefined) {
                this.editContactName.key = "billContactName";
                this.adminConfigService.createDivSetting(this.editContactName)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin Name Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editContactName)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin Name Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }

            if (_.isEmpty(this.emailAddress) && this.editEmailAddress !== undefined) {
                this.editEmailAddress.key = "billEmailAddress";
                this.adminConfigService.createDivSetting(this.editEmailAddress)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin email Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editEmailAddress)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin email Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }

            if (_.isEmpty(this.billingAddress) && this.editBillingAddress !== undefined) {
                this.editBillingAddress.key = "billBillingAddress";
                this.adminConfigService.createDivSetting(this.editBillingAddress)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin contact Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editBillingAddress)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Div Admin contact Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }

            if (_.isEmpty(this.suiteNumber) && this.editSuiteNumber !== undefined) {
                this.editSuiteNumber.key = "billSuiteNumber";
                this.adminConfigService.createDivSetting(this.editSuiteNumber)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Tech Admin Name Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editSuiteNumber)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Tech Admin Name Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }

            if (_.isEmpty(this.city) && this.editCity !== undefined) {
                this.editCity.key = "billCity";
                this.adminConfigService.createDivSetting(this.editCity)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Tech Admin email Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editCity)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Tech Admin email Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }

            if (_.isEmpty(this.state) && this.editState !== undefined) {
                this.editState.key = "billState";
                this.adminConfigService.createDivSetting(this.editState)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Tech Admin contact Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editState)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error Tech Admin contact Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }


            if (_.isEmpty(this.country) && this.editCountry !== undefined) {
                this.editCountry.key = "billCountry";
                this.adminConfigService.createDivSetting(this.editCountry)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error URL Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editCountry)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error URL Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
        }
        catch (ex) {
            alert(ex);
        }
        finally {

            this.contactName = [];
            this.emailAddress = [];
            this.billingAddress = [];
            this.suiteNumber = [];
            this.city = [];
            this.state = [];
            this.country = [];

            this.editContactName = null;
            this.editEmailAddress = null;
            this.editBillingAddress = null;

            this.editSuiteNumber = null;
            this.editCity = null;
            this.editState = null;

            this.editCountry = null;

            this.notifyService.endProgress();
            setTimeout(this.Init(), 5);
        }
    };

    UpdatePayment() {
        try {
            this.notifyService.startProgress();
            if (_.isEmpty(this.billingMethod) && this.editBillingMethod !== undefined) {
                this.editBillingMethod.key = "billMethod";
                this.adminConfigService.createDivSetting(this.editBillingMethod)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error URL Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
            else {
                this.adminConfigService.updateDivSetting(this.editBillingMethod)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error URL Setting");
                        }
                    }).finally(() => {
                        this.Init();
                    });
            }
        }
        finally {

            this.notifyService.endProgress();
            setTimeout(this.Init(), 5);
        }

    }
}